import type { ComponentSchema } from "../../../../../schema-types";
import { SUPPORTED_PAGES, SECTION_STYLE_FIELDS } from "../../_builder-constants";

const INSTAGRAM_ITEM_SCHEMA = [
  { key: "image", label: "Image", type: "image" as const },
  { key: "link", label: "Link URL", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "instagram-feed",
  label: "Instagram Feed",
  description: "Display a grid of Instagram photos with hover effects.",
  supportedPages: [...SUPPORTED_PAGES],
  variants: [
    {
      id: "v1",
      label: "V1 — 5-Column Photo Grid",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle (e.g. @urbandrip)", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
    {
      id: "v2",
      label: "V2 — 6-Column with Handle Overlay",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
    {
      id: "v3",
      label: "V3 — 4-Column Large Tiles",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
    {
      id: "v4",
      label: "V4 — Masonry Style with Header",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "handle", label: "Instagram Handle", type: "string" },
        { key: "items", label: "Photos", type: "array", itemSchema: INSTAGRAM_ITEM_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
